import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'computer-header-style-2',
})
export default class ComputerHeaderStyle2Component extends Vue {
  /** This header is used for the views:
   *  SelectPhone
   *  SelectEmail
   */
}
